import React from 'react';
import DropTrack from '../../../../Assets/DropTrack/Droptrack.svg';
import { useSelector } from 'react-redux';

function Alert() {
    const dropTrackProduct = useSelector((state) => state.dropTrackProducts.dropTrackProduct.dropTrackProduct);

    return (
        <div className="bg-[#BCFCD7] rounded-[7px] px-4 py-[10px] flex items-center gap-2 mt-4 mx-5">
            <div className="select-none">
                <img src={DropTrack} alt="" />
            </div>
            
            <p className='font-medium text-base text-[#121212] select-none'>
                <span className='font-bold'>{dropTrackProduct.dropWatch} shopper{dropTrackProduct.dropWatch > 1 ? 's' : ''}</span> {dropTrackProduct.dropWatch > 1 ? 'are' : 'is'} watching this product for a price drop. Seize this opportunity to convert interest into revenue with a smart offer.
            </p>
        </div>
    );
}

export default Alert;
